var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import LogService from '../../utils/log';
import { APIService } from '../../services/api';
import { DeliveryTypes, addressFields, personalFields, } from '../../order-fields';
import { ASAP, STRIPE_API_KEY } from '../../config';
import { isValidEmail, isValidPhone, validateRequired, } from '../../utils/validation';
import { getAllowedDeliveryOptions, getAllowedPaymentOptions, } from '../../utils/order';
import { hasLocalStorageAccess } from '../../pwa';
import { getAppSource } from '../../utils/url-params';
import { getIsMinDeliveryAchieved } from 'Utils/basket-status';
import DeliveryService from 'Utils/location';
import { getSafeLsJSON } from 'Utils/parsers';
import CustomerService from 'Utils/customer';
export var LS_SAVED_ORDER_DATA = 'saved-order-form-data';
var fixCartItemAdditionalField = function (cartItem) {
    if (!cartItem.additionalFields || !cartItem.additionalFields.map) {
        return cartItem;
    }
    cartItem.additionalFields.map(function (field) {
        if (field && field.value && typeof field.value === 'string') {
            field.value = field.value.split(',').map(function (s) { return s.trim(); });
        }
    });
    return cartItem;
};
export function handleOrderFormSubmit(values, formikBag) {
    var props = formikBag.props, setErrors = formikBag.setErrors, setSubmitting = formikBag.setSubmitting;
    var deliveryAt = values.deliveryAt, deliveryTime = values.deliveryTime, payment = values.payment, otherFormFields = __rest(values, ["deliveryAt", "deliveryTime", "payment"]);
    var basketStatus = props.basketStatus, cart = props.cart, restaurant = props.restaurant, promoCode = props.promoCode;
    var deliveryCost = values.delivery === DeliveryTypes.takeout ? 0 : basketStatus.price.delivery;
    var deliveryPrefs = DeliveryService.getDeliveryPreferences();
    var payloadOrder = __assign({ customer: __assign(__assign(__assign({}, otherFormFields), { deliveryAt: deliveryAt }), (deliveryPrefs ? deliveryPrefs.coordinates : {})), source: getAppSource(), products: cart.map(fixCartItemAdditionalField), payment_type: payment, price: basketStatus.price.discounted, delivery_cost: deliveryCost, delivery_type: values.delivery }, getPromoCodeOrderPart(promoCode));
    hasLocalStorageAccess() &&
        localStorage.setItem(LS_SAVED_ORDER_DATA, JSON.stringify(values));
    var FOR_WHO = "".concat(restaurant.id, " ").concat(restaurant.name);
    var url = "/restaurants/".concat(restaurant.id, "/orders");
    // @ts-ignore Stripe will be loaded
    var stripe = Stripe(STRIPE_API_KEY);
    return APIService.post(url, payloadOrder)
        .then(function (response) {
        if (response.status === 200) {
            return response.json();
        }
        else {
            LogService.error("".concat(FOR_WHO, " Other response status than 200"), response);
            console.warn('OrderFormHelpers #1 (response is not 200) sets setSubmitting to false');
            setSubmitting(false);
        }
    })
        .then(function (order) {
        props.onOrderCreate(order, stripe, setErrors, setSubmitting);
        return false;
    })
        .catch(function (e) {
        console.warn('OrderFormHelpers #3 (catch) sets setSubmitting to false');
        setSubmitting(false);
        LogService.error("".concat(FOR_WHO, " OrderForm post"), e);
    });
}
// TODO make promo code always object or always string
function getPromoCodeOrderPart(promoCode) {
    if (!promoCode) {
        return {};
    }
    if (typeof promoCode === 'string') {
        return {
            promo_code: promoCode,
            promo_code_name: promoCode,
        };
    }
    if (!!promoCode.id) {
        return {
            promo_code_id: promoCode.id,
        };
    }
    return {};
}
export function getOrderFormInitialValues(props) {
    var basketStatus = props.basketStatus, deliveryMode = props.deliveryMode, restaurantDetails = props.restaurantDetails;
    var lsValues = getSafeLsJSON(LS_SAVED_ORDER_DATA, {});
    var getCachedField = function (name, def) {
        if (def === void 0) { def = ''; }
        return lsValues[name] || def;
    };
    // let values: Partial<TOrderFormValues> = {
    //   customer_firstname: '',
    //   customer_lastname: '',
    //   email: '',
    //   phone: '',
    // }
    var customerData = CustomerService.getSavedCustomerData();
    var deliveryPrefs = DeliveryService.getDeliveryPreferences();
    // personalFields.forEach((f) => (values[f.name] = customerData[f.name] || ''))
    // addressFields.forEach((f) => (values[f.name] = deliveryPrefs[f.name] || ''))
    var delivery = getDefaultDelivery({
        basketStatus: basketStatus,
        deliveryMode: deliveryMode,
        getCachedField: getCachedField,
        restaurantDetails: restaurantDetails,
    });
    var allowedPaymentKeys = getAllowedPaymentOptions(restaurantDetails, delivery).map(function (payment) { return payment.name; });
    var cachedPayment = getCachedField('payment', null);
    var payment = allowedPaymentKeys.includes(cachedPayment)
        ? cachedPayment
        : allowedPaymentKeys[0];
    return {
        // ...values,
        customer_firstname: customerData.customer_firstname || '',
        customer_lastname: customerData.customer_lastname || '',
        email: customerData.email || '',
        phone: customerData.phone || '',
        address: (deliveryPrefs === null || deliveryPrefs === void 0 ? void 0 : deliveryPrefs.address) || '',
        house: (deliveryPrefs === null || deliveryPrefs === void 0 ? void 0 : deliveryPrefs.house) || '',
        flat: (deliveryPrefs === null || deliveryPrefs === void 0 ? void 0 : deliveryPrefs.flat) || '',
        city: '',
        street: '',
        cutleryPreferences: '',
        notes: '',
        delivery: delivery,
        deliveryTime: ASAP,
        deliveryAt: '',
        payment: payment,
        allowMarketing: false,
        allowSms: false,
        allowEmail: false,
    };
}
function getDefaultDelivery(_a) {
    var basketStatus = _a.basketStatus, deliveryMode = _a.deliveryMode, restaurantDetails = _a.restaurantDetails, getCachedField = _a.getCachedField;
    var isCartEnoughForDelivery = getIsMinDeliveryAchieved(basketStatus);
    var cachedDelivery = getCachedField('delivery', null);
    var allowedDeliveries = getAllowedDeliveryOptions(restaurantDetails);
    var isTakeoutAllowed = !!allowedDeliveries.find(function (item) { return item.name === DeliveryTypes.takeout; });
    if (deliveryMode === DeliveryTypes.usual && isCartEnoughForDelivery) {
        return cachedDelivery === DeliveryTypes.contactless
            ? DeliveryTypes.contactless
            : DeliveryTypes.usual;
    }
    if (deliveryMode === DeliveryTypes.takeout && isTakeoutAllowed) {
        return DeliveryTypes.takeout;
    }
    if (allowedDeliveries.find(function (item) { return item.name === cachedDelivery; })) {
        return cachedDelivery;
    }
    else {
        return allowedDeliveries[0].name;
    }
}
export function validateOrderForm(values) {
    var errors = validateCustomerFields(values);
    if (values.delivery !== DeliveryTypes.takeout) {
        addressFields.forEach(function (field) { return validateRequired(field, values, errors); });
    }
    return errors;
}
export function validateCustomerFields(values) {
    var errors = {};
    personalFields.forEach(function (field) { return validateRequired(field, values, errors); });
    if (values.phone) {
        if (!isValidPhone(values.phone)) {
            LogService.error("Someones phone is invalid ".concat(values.phone));
            errors.phone = 'Podany numer telefonu jest nieprawidłowy';
        }
    }
    if (values.email) {
        if (!isValidEmail(values.email)) {
            LogService.error("Someones email is invalid ".concat(values.email));
            errors.email = 'Podany email jest nieprawidłowy';
        }
    }
    return errors;
}
